<template>
    <div class="examDetailCont">
      <div class="examDetail__content">
        <div class="n-ex-in-body">
          <el-container v-if="examObj && examDetail">
            <div class="el-mainLeft">
              <div class="title">
                <p>{{examObj.exerciseName}}共（{{totalNum}}）题</p>
              </div>
              <div class="examTopic">
                <div class="questions-stems">
                  <p v-if="isHint" style="color:red;font-size: 18px;">注: 考试时间即将结束, 结束后, 试卷将自动提交</p>
                  <div class="questions-stems-title">
                    <i
                      class="fa fa-bookmark"
                      style=" font-size: 32px; color: #3482ff;position: relative;top:23px;"
                    >
                      <label class="tNum">{{examDetail.number}}</label>
                    </i>
                    <label
                      style="font-weight: bold;font-size: 16px;line-height: 30px;"
                    >{{examDetail.content}}</label>
                  </div>
                  <img
                    style="width: 350px; height: 250px; margin-top: 20px;"
                    v-if="examDetail.filePath!=undefined&&examDetail.filePath!=''"
                    :src="examDetail.filePath"
                  />
                  <div class="questions-stems-content" v-if="examObj.isShowRightAnswer">
                    <!--显示答案-->
                    <el-checkbox-group
                      v-model="radio"
                      v-if="examDetail.questionType=='单选题'||examDetail.questionType=='判断题'"
                      :disabled="examDetail.isDisabled"
                      :class="examDetail.isRight?'isCorrect':'noCorrect'"
                    >
                      <el-checkbox
                        v-for="(detail,index) in examDetail.questionAnswers"
                        :key="detail.id"
                        :label="detail.id"
                        @change="clickAnswer(examDetail,detail)"
                      >{{detail.nName}}. {{detail.content}}</el-checkbox>
                    </el-checkbox-group>
                    <el-checkbox-group
                      v-model="checkedCities"
                      v-if="examDetail.questionType=='多选题'"
                      :disabled="examDetail.isDisabled"
                      :class="examDetail.isRight?'isCorrect':'noCorrect'"
                    >
                      <el-checkbox
                        v-for="(detail,index) in examDetail.questionAnswers"
                        :label="detail.id"
                        :key="detail.id"
                      >{{detail.nName}}. {{detail.content}}</el-checkbox>
                    </el-checkbox-group>
                    <el-button
                      style="margin-top: 20px;"
                      type="primary"
                      v-if="examDetail.questionType=='多选题'"
                      @click="checkboxAnswer(examDetail)"
                    >确认答案</el-button>
                  </div>
                  <div class="questions-stems-content" v-if="!examObj.isShowRightAnswer">
                    <!--不显示答案-->
                    <el-checkbox-group
                      v-model="radio"
                      v-if="examDetail.questionType=='单选题'||examDetail.questionType=='判断题'"
                    >
                      <el-checkbox
                        v-for="(detail,index) in examDetail.questionAnswers"
                        :key="detail.id"
                        :label="detail.id"
                        @change="clickAnswer(examDetail,detail)"
                      >{{detail.nName}}. {{detail.content}}</el-checkbox>
                    </el-checkbox-group>
                    <el-checkbox-group
                      v-model="checkedCities"
                      v-if="examDetail.questionType=='多选题'"
                    >
                      <el-checkbox
                        v-for="(detail,index) in examDetail.questionAnswers"
                        :label="detail.id"
                        :key="detail.id"
                      >{{detail.nName}}. {{detail.content}}</el-checkbox>
                    </el-checkbox-group>
                    <el-button
                      style="margin-top: 20px;"
                      type="primary"
                      v-if="examDetail.questionType=='多选题'"
                      @click="checkboxAnswer(examDetail)"
                    >确认答案</el-button>
                  </div>
                </div>
              </div>
              <div
                class="answer-keys"
                v-if="!examDetail.isRight&&examDetail.isRight!=undefined&&examObj.isShowRightAnswer"
              >
                <p style="padding-left: 20px;">回答错误！正确答案：{{examDetail.rightAnswerName}}</p>
              </div>
              <div class="foot">
                <el-button type="primary" @click="onTopic" :disabled="examDetail.number==1">上一题</el-button>
                <el-button
                  type="primary"
                  @click="nextQuestion"
                  :disabled="examDetail.number==totalNum"
                >下一题</el-button>
                <el-button type="warning" @click="restart">重新开始</el-button>
                <el-button type="danger" @click="subPaper">交卷</el-button>
              </div>
              <div class="answer-keys" v-if="examObj.isShowRightAnswer">
                <el-collapse v-model="activeName">
                  <el-collapse-item title="查看详解" name="1">
                    <p style="padding-left: 20px;">正确答案：{{examDetail.rightAnswerName}}</p>
                    <div style="padding-top: 15px">{{examDetail.analysis}}</div>
                  </el-collapse-item>
                </el-collapse>
              </div>
            </div>
            <el-aside width="300px" class="aside-content">
              <!--答题卡-->
              <div class="answer-sheet-content">
                <p class="timeTitle">
                  <i class="fa fa-clock-o" style="padding-right:5px;"></i>
                  {{isLimitTime?"剩余时间":"用时"}}:
                  <span
                    style="padding-left: 5px;font-size:22px;font-weight: bold;color:rgb(39, 39, 39)"
                  >{{keepTime}}</span>
                </p>
                <div class="dtkShow">
                  <h2 class="dtkTitle">答题卡</h2>
                  <div class="answer-sheet-list">
                    <div v-for="(aObj,index) in answerSheetList" :key="index">
                      <h1
                        class="selOption"
                      >{{aObj.titleName}}</h1>
                      <!-- （{{ aObj.count }}/{{ aObj.arraySum }}） -->
                      <ul>
                        <li
                          v-for="(obj,index) in aObj.list"
                          @click="clickAnswerSheet(obj)"
                          :key="index"
                        >
                          <div v-if="examObj.isShowRightAnswer">
                            <a
                              v-if="obj.isRight!=undefined"
                              :class="obj.isRight?'isTrue':'isFalse'"
                            >{{obj.number}}</a>
                            <a v-if="obj.isRight==undefined">{{obj.number}}</a>
                          </div>
                          <div v-if="!examObj.isShowRightAnswer">
                            <a :class="obj.isRight!=undefined?'isExist':''">{{obj.number}}</a>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </el-aside>
          </el-container>
        </div>
      </div>

      <el-dialog title="打卡拍照" :visible.sync="dialogTableVisible" :before-close="handleClose" append-to-body>
        <div class="camera-box">
          <CameraDialog
            ref="camera2"
            :clearFaTimer="clearFaTimer"
            :videoWidth="200"
            :videoHeight="200"
            @child-url="getUlr2"
          />
        </div>
        <div style="text-align: center;margin-top: 25px;margin-bottom: 25px">
          <el-button type="primary" @click="photograph">拍照</el-button>
          <el-button @click="startExam" plain>开始做题</el-button>
        </div>
        <div>
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>实时相册（注：当相册为空时，审核将会不通过，请勿提交试卷）</span>
            </div>
            <img
              class="photo"
              v-for="(imgUlr,index) in imgUlrList"
              :key="index"
              :src="imgUlr.url"
              alt
            />
          </el-card>
        </div>
      </el-dialog>
    
    </div>
</template>
<script>
import {
    exerciseDetails,
    submitPaperExercise,
    updateExerciseFlag,
    faceComparison
  } from '@/apiCloud/examList'
  import {
  getUserCourseStudyDetail
  } from '../../apiCloud/courseDetail'
  import {
    timeLength
  } from '@/utils/ruoyi'
    import CameraDialog from "../CameraDialog/CameraDialog.vue"

  
  
  let that;
  let int;
  Date.prototype.Format = function (fmt) {
    let o = {
      "M+": this.getMonth() + 1, //月份
      "d+": this.getDate(), //日
      "h+": this.getHours(), //小时
      "m+": this.getMinutes(), //分
      "s+": this.getSeconds(), //秒
      "q+": Math.floor((this.getMonth() + 3) / 3), //季度
      "S": this.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (let k in o)
      if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
    return fmt;
  
  };
  export default {
    props: ['exerciseId','courseId','regId','ccId','needPracticePhoto'],
    components:{
      CameraDialog
    },
    data() {
      return {
        contentHeight: {
          height: ''
        },
        dataConfig: {},
        radio: [],
        examObj: {},
        oldExamObj: {},
        examDetail: {},
        answerSheetList: [],
        checkedCities: [],
        keepTime: "",
        userAnswerList: [],
        totalNum: 0,
        hour: 0,
        minute: 0,
        second: 0,
        millisecond: 0,
        limitTime: "",
        isHint: false,
        beginDateTime: "",
        isLimitTime: false,
        activeName: '',
        isShowRightAnswer: false, //是否显示答案

        dialogTableVisible:false,
        imgUlrList: []
      }
    },
    watch:{
      needPracticePhoto:{
        handler(val){
          if(val == 1){
            this.dialogTableVisible = true
          }
        },
        immediate:true
      }
    },
    created() {
      that = this;
      that.contentHeight.height = window.innerHeight - 480 + 'px';
      setTimeout(function () {
        that.getCateExerciseList();
      }, 600)
    },
    methods: {
      //清除定时器
      clearFaTimer() {
        console.log("？？？")
      },
      //练习详情
      getCateExerciseList() {
        // let url = "exercise/exerciseDetails";
        let data = {
          exerciseId: this.exerciseId
        };
        exerciseDetails(data).then(res => {
          if (res.code == 200) {
            that.isLimitTime = res.data.isLimitTime;
            that.oldExamObj = res.data;
            that.limitTime = res.data.limitTime;
            that.isShowRightAnswer = res.data.isShowRightAnswer;
            that.examObj = {};
            that.answerSheetList = [];
            that.examObj = JSON.parse(JSON.stringify(that.oldExamObj));
            var number = 0;
            that.examObj.paperEntity.paperAreaList.forEach((obj) => {
              obj.questionList.forEach((questionObj) => {
                number = number + 1;
                questionObj.number = number;
                var answerN = "";
                questionObj.questionAnswers.forEach((answersObj, index) => {
                  switch (index) {
                    case 0:
                      answersObj.nName = "A";
                      break;
                    case 1:
                      answersObj.nName = "B";
                      break;
                    case 2:
                      answersObj.nName = "C";
                      break;
                    case 3:
                      answersObj.nName = "D";
                      break;
                    case 4:
                      answersObj.nName = "E";
                      break;
                    case 5:
                      answersObj.nName = "F";
                      break;
                    case 6:
                      answersObj.nName = "G";
                      break;
                  }
                  if (answersObj.isRight) {
                    if (answerN != "") {
                      answerN = answerN + "," + answersObj.nName
                    } else {
                      answerN = answerN + answersObj.nName
                    }
  
                  }
                });
                questionObj.rightAnswerName = answerN;
              });
              that.answerSheetList.push({
                titleName: obj.paperAreaName,
                list: obj.questionList
              })
            });
            that.examDetail = that.examObj.paperEntity.paperAreaList[0].questionList[0];
            that.totalNum = that.answerSheetList[that.answerSheetList.length - 1].list[that.answerSheetList[that.answerSheetList.length - 1].list.length - 1].number
            that.start();
            that.beginDateTime = (new Date()).Format("yyyy-MM-dd hh:mm:ss");
          } else {
            this.$message.error(res.message)
          }
        })
      },
      clickAnswer(examDetail, detail) { //单选题 选择答案 examDetail:题目详情  detail:答案详情
        that.radio = [detail.id];
        /*循环答题卡,修改答题卡状态*/
        that.answerSheetList.forEach((answerSheetObj) => {
          answerSheetObj.list.forEach((obj) => {
            obj.questionAnswers.forEach((answersObj) => {
              if (answersObj.id == detail.id) {
                obj.isRight = detail.isRight;
                examDetail.isRightUser = detail.isRight;
                obj.answerId = detail.id;
              }
              if (examDetail.id == obj.id && answersObj.isRight) {
                obj.answerName = answersObj.nName;
                examDetail.answerName = answersObj.nName;
              }
            });
  
          })
        });
  
        var indexNext = 0;
        var isRight = false;
        var isExist = false;
        that.examObj.paperEntity.paperAreaList.forEach((obj) => {
          obj.questionList.forEach((questionObj, index) => {
            questionObj.questionAnswers.forEach((answersObj) => {
              if (answersObj.id == detail.id) {
                questionObj.isRight = detail.isRight;
                questionObj.answerId = detail.id;
                if (index == obj.questionList.length - 1) {
                  indexNext = 0;
                } else {
                  indexNext = index + 1;
                }
                isRight = detail.isRight;
              }
            });
  
            if (this.isShowRightAnswer == true) {
              if (indexNext == index && isRight && that.examObj.exerciseType == "1") { //答对的话 默认跳转到下一题
                that.examDetail = questionObj;
                if (questionObj.isRight != undefined && questionObj.answerId != undefined) {
                  that.examDetail.isDisabled = true;
                  that.radio = [questionObj.answerId];
                } else {
                  that.examDetail.isDisabled = false;
                  that.radio = [];
                }
                isRight = false;
                isExist = true;
                that.activeName = "";
                return false;
              }
            }
  
          });
        });
        if (!isExist && that.examObj.exerciseType == "1") {
          that.examDetail.isDisabled = true;
        }
  
      },
      checkboxAnswer(examDetail) { //多选题 选择答案 examDetail:题目详情  detail:答案详情
        that.activeName = "";
        that.checkedCities.sort(function (a, b) {
          return a - b;
        });
        var answerId = "";
        that.checkedCities.forEach(function (c) {
          answerId = answerId + c + ","
        });
        var answer = "";
        var answerN = "";
        var answerList = [];
        that.examObj.paperEntity.paperAreaList.forEach((obj) => {
          obj.questionList.forEach((questionObj, index) => {
            questionObj.questionAnswers.forEach((answersObj, index) => {
              if (examDetail.id == questionObj.id) {
                questionObj.answerId = answerId;
                if (answersObj.isRight) {
                  answerList.push(answersObj.id);
                  answerN = answerN + answersObj.nName + ","
                }
                if (index + 1 == questionObj.questionAnswers.length) {
                  answerList.sort(function (a, b) {
                    return a - b;
                  });
                  answerList.forEach(function (t) {
                    answer = answer + t + ","
                  });
                  questionObj.answerName = answerN;
                  if (answer == answerId) {
                    questionObj.isRight = true;
                    if (that.examObj.exerciseType == "1") {
                      {
                        that.nextQuestion();
                      }
                    }
                  } else {
                    that.examDetail.isDisabled = true;
                    questionObj.isRight = false;
                    that.examDetail = questionObj;
                  }
                }
              }
            });
          });
        });
  
      },
      clickAnswerSheet(detail) { //点击答题卡
        that.activeName = "";
        that.examDetail = detail;
        that.checkedCities = [];
        that.radio = [];
        var list = [];
        if (that.examDetail.questionType == "多选题") {
          if (that.examDetail.answerId != undefined) {
            list = that.examDetail.answerId.split(",");
            list.forEach(function (k) {
              if (k !== "") {
                that.checkedCities.push(parseInt(k));
              }
            })
          }
  
        } else {
          that.radio.push(detail.answerId);
        }
        if (detail.answerId != undefined && that.examObj.exerciseType == "1") {
          that.examDetail.isDisabled = true;
        }
      },
      onTopic() { //上一题
        that.activeName = "";
        if (that.examDetail.number == that.totalNum) {
          this.$message({
            type: 'warning',
            message: '注:该题已是试卷最后一题,请检查试卷是否都已做完'
          });
        } else {
  
        }
        that.checkedCities = [];
        that.radio = [];
        for (var c = 0; c < that.answerSheetList.length; c++) {
          for (var i = 0; i < that.answerSheetList[c].list.length; i++) {
            if (that.answerSheetList[c].list[i].id == that.examDetail.id) {
              if (i != 0) {
                that.examDetail = that.answerSheetList[c].list[i - 1];
              } else {
                that.examDetail = that.answerSheetList[c - 1].list[that.answerSheetList[c - 1].list.length - 1];
              }
  
            }
          }
        }
        if (that.examDetail.questionType == "多选题") {
          if (that.examDetail.answerId != undefined) {
            var list = that.examDetail.answerId.split(",");
            list.forEach(function (k) {
              if (k !== "") {
                that.checkedCities.push(parseInt(k));
              }
            })
          }
  
        } else {
          that.radio.push(that.examDetail.answerId);
        }
        if (that.examDetail.answerId != undefined && that.examObj.exerciseType == "1") {
          that.examDetail.isDisabled = true;
        }
      },
      nextQuestion() { //下一题
        that.activeName = "";
        if (that.examDetail.number == that.totalNum) {
          this.$message({
            type: 'warning',
            message: '注:该题已是试卷最后一题,请检查试卷是否都已做完'
          });
          that.examDetail.isDisabled = true;
          return false
        } else {
  
        }
        that.checkedCities = [];
        that.radio = [];
  
        var detail = {};
        for (var c = 0; c < that.answerSheetList.length; c++) {
          for (var i = 0; i < that.answerSheetList[c].list.length; i++) {
            if (that.answerSheetList[c].list[i].id == that.examDetail.id) {
              if (i >= that.answerSheetList[c].list.length - 1) {
                detail = that.answerSheetList[c + 1].list[0];
              } else {
                detail = that.answerSheetList[c].list[i + 1];
              }
  
            }
          }
        }
        that.examDetail = detail;
        if (that.examDetail.questionType == "多选题") {
          if (that.examDetail.answerId != undefined) {
            var list = that.examDetail.answerId.split(",");
            list.forEach(function (k) {
              if (k !== "") {
                that.checkedCities.push(parseInt(k));
              }
            })
          }
  
        } else {
          that.radio.push(that.examDetail.answerId);
        }
        if (that.examDetail.answerId != undefined) {
          that.examDetail.isDisabled = true;
        }
      },
      subPaper() { //交卷
        var totalTime = "";
        if (that.isLimitTime) {
          var residueTime = that.hour * 3600000 + that.minute * 60000 + that.second * 1000; //模拟考剩余时间
          var totleTime = that.limitTime * 60000; //考试总时间
          var availableTime = (totleTime - residueTime) / 60000;
          var hour = parseInt(availableTime / 60);
          var minute = parseInt(availableTime % 60);
          var second = (availableTime * 60) % 60;
          var hourObj = hour > 9 ? hour : "0" + hour;
          var minuteObj = minute > 9 ? minute : "0" + minute;
          var secondObj = second > 9 ? second : "0" + second;
          totalTime = hourObj + ':' + minuteObj + ':' + secondObj;
        } else {
          totalTime = that.keepTime;
        }
        this.$confirm('确定要交卷吗', '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          totalTime = timeLength(that.beginDateTime, new Date(), true);
          var paramData = {
            "exerciseId": that.examObj.exerciseId,
            "score": 0,
            "beginDateTime": that.beginDateTime,
            "totalTime": totalTime,
            courseId: that.$route.query.courseId,
            paperId: that.examObj.paperEntity.paperId,
            "endDateTime": (new Date()).Format("yyyy-MM-dd hh:mm:ss"),
            "exerciseAnswersList": [],
          };
          var score = 0;
          that.examObj.paperEntity.paperAreaList.forEach((obj) => {
            obj.questionList.forEach((questionObj) => {
              if (questionObj.isRight) {
                score = score + questionObj.score
              }
              paramData.exerciseAnswersList.push({
                "isRight": questionObj.isRight != undefined && questionObj.isRight ? questionObj.isRight : false,
                "answerName": questionObj.answerName ? questionObj.answerName : "",
                "answerId": questionObj.answerId ? questionObj.answerId.toString() : "",
                "questionId": questionObj.id,
                "paperAreaId": obj.id
              })
            });
          });
          that.examObj.totalTime = totalTime;
          that.examObj.beginDateTime = that.beginDateTime; //开始时间
          that.examObj.assignmentTime = (new Date()).Format("yyyy-MM-dd hh:mm:ss"); //交卷时间;
          paramData.score = score;
          paramData.courseId = that.courseId;
            let data = {
              paperJson: JSON.stringify(paramData),
              resultShow: that.dataConfig.resultShow,
              detailShow: 1,
              courseId: that.courseId,
              regId: that.regId,
              photoUrl: (that.imgUlrList[0] || {}).url,
              type: 1
            };
            submitPaperExercise(data).then(res => {
              if (res.code == 200) {
                let data={
                  regId: that.regId,
                  ccId: that.ccId,
                }
                updateExerciseFlag(data).then(res=>{
                  if(res.code ==200){
                    let params={ 
                      courseId: that.courseId,
                      regId: that.regId
                    }
                    getUserCourseStudyDetail(params).then(res=>{
                    if(res.code == 200){
                        that.close()
                      }
                    })
                  }
                })
              } else {
                this.$message.error(res.msg)
              }
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
      },
      restart() { //重新开始
        this.$confirm('确定要重新开始吗', '提示', {
          confirmButtonText: '是的',
          cancelButtonText: '再想想',
          type: 'warning'
        }).then(() => {
          that.radio = [];
          that.examObj = {};
          that.answerSheetList = [];
          that.examObj = JSON.parse(JSON.stringify(that.oldExamObj));
          var number = 0;
          that.examObj.paperEntity.paperAreaList.forEach((obj) => {
            obj.questionList.forEach((questionObj) => {
              number = number + 1;
              questionObj.number = number;
              var answerN = "";
              questionObj.questionAnswers.forEach((answersObj, index) => {
                switch (index) {
                  case 0:
                    answersObj.nName = "A";
                    break;
                  case 1:
                    answersObj.nName = "B";
                    break;
                  case 2:
                    answersObj.nName = "C";
                    break;
                  case 3:
                    answersObj.nName = "D";
                    break;
                  case 4:
                    answersObj.nName = "E";
                    break;
                  case 5:
                    answersObj.nName = "F";
                    break;
                  case 6:
                    answersObj.nName = "G";
                    break;
                }
                if (answersObj.isRight) {
                  if (answerN != "") {
                    answerN = answerN + "," + answersObj.nName
                  } else {
                    answerN = answerN + answersObj.nName
                  }
  
                }
              });
              questionObj.rightAnswerName = answerN;
            });
            that.answerSheetList.push({
              titleName: obj.paperAreaName,
              list: obj.questionList
            })
          });
          that.examDetail = that.examObj.paperEntity.paperAreaList[0].questionList[0];
          that.totalNum = that.answerSheetList[that.answerSheetList.length - 1].list[that.answerSheetList[that.answerSheetList.length - 1].list.length - 1].number
          that.start();
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          });
        });
  
      },
      timer() {
        that.millisecond = that.millisecond + 50;
        that.second = that.second + 1;
        if (that.second >= 60) {
          that.second = 0;
          that.minute = that.minute + 1;
        }
  
        if (that.minute >= 60) {
          that.minute = 0;
          that.hour = that.hour + 1;
        }
        var hourObj = that.hour > 9 ? that.hour : "0" + that.hour;
        var minuteObj = that.minute > 9 ? that.minute : "0" + that.minute;
        var secondObj = that.second > 9 ? that.second : "0" + that.second;
        that.keepTime = hourObj + ':' + minuteObj + ':' + secondObj;
      },
      timer2() {
        /*模拟考 减*/
        if (that.hour == 0 && that.minute <= 15 && that.isLimitTime) {
          that.isHint = true;
        }
        if (that.hour === 0 && that.minute === 0 && that.second === 0 && that.isLimitTime) {
          window.clearInterval(int);
          this.$alert("考试时间已结束,已提交试卷", '提示', {
            confirmButtonText: '确定',
            callback: action => {
              var totalTime = "";
              if (that.isLimitTime) {
                var residueTime = that.hour * 3600000 + that.minute * 60000 + that.second * 1000; //模拟考剩余时间
                var totleTime = that.limitTime * 60000; //考试总时间
                var availableTime = (totleTime - residueTime) / 60000;
                var hour = parseInt(availableTime / 60);
                var minute = parseInt(availableTime % 60);
                var second = (availableTime * 60) % 60;
                var hourObj = hour > 9 ? hour : "0" + hour;
                var minuteObj = minute > 9 ? minute : "0" + minute;
                var secondObj = second > 9 ? second : "0" + second;
                totalTime = hourObj + ':' + minuteObj + ':' + secondObj;
              } else {
                totalTime = that.keepTime;
              }
              var paramData = {
                "exerciseId": that.examObj.exerciseId,
                "score": 0,
                courseId: that.courseId,
                paperId: that.examObj.paperEntity.paperId,
                "beginDateTime": that.beginDateTime,
                "endDateTime": (new Date()).Format("yyyy-MM-dd hh:mm:ss"),
                "totalTime": totalTime,
                "exerciseAnswersList": [],
              };
              var score = 0;
              that.examObj.paperEntity.paperAreaList.forEach((obj) => {
                obj.questionList.forEach((questionObj) => {
                  if (questionObj.isRight) {
                    score = score + questionObj.score
                  }
                  paramData.exerciseAnswersList.push({
                    "isRight": questionObj.isRight ? questionObj.isRight : false,
                    "answerName": questionObj.answerName ? questionObj.answerName : "",
                    "answerId": questionObj.answerId ? questionObj.answerId : "",
                    "questionId": questionObj.id
                  })
                });
              });
              that.examObj.totalTime = totalTime;
              that.examObj.beginDateTime = that.beginDateTime; //开始时间
              that.examObj.assignmentTime = (new Date()).Format("yyyy-MM-dd hh:mm:ss"); //交卷时间
              paramData.score = score;
                let data = {
                  paperJson: JSON.stringify(paramData),
                  resultShow: that.dataConfig.resultShow,
                  detailShow: 1,
                  courseId: that.courseId,
                  regId: that.regId,
                  photoUrl: (that.imgUlrList[0] || {}).url,
                  type: 1
                };
                submitPaperExercise(data).then(res => {
                  if (res.code == 200) {
                    let data={
                      regId: that.regId,
                      ccId: that.ccId,
                    }
                    updateExerciseFlag(data).then(res=>{
                      if(res.code ==200){
                        let params={ 
                          courseId: that.courseId,
                          regId: that.regId
                        }
                        getUserCourseStudyDetail(params).then(res=>{
                        if(res.code == 200){
                            that.close()
                          }
                        })
                      }
                    })
                  } else {
                    this.$message.error(res.msg)
                  }
                }
                )}
              });
        } else {
          that.second = that.second - 1;
        }
        if (that.second <= 0 && that.minute > 0) {
          that.second = 60;
          that.minute = that.minute - 1;
        }
  
        if (that.minute <= 0 && that.hour > 0) {
          that.minute = 60;
          that.hour = that.hour - 1;
        }
        var hourObj = that.hour > 9 ? that.hour : "0" + that.hour;
        var minuteObj = that.minute > 9 ? that.minute : "0" + that.minute;
        var secondObj = that.second > 9 ? that.second : "0" + that.second;
        that.keepTime = hourObj + ':' + minuteObj + ':' + secondObj;
      },
      //开始函数
      start() {
        that.hour = 0;
        that.minute = 0;
        that.second = 0; //初始化
        window.clearInterval(int);
        if (that.limitTime != undefined && that.limitTime !== "" && that.limitTime !== 0) {
          if (that.limitTime > 60) {
            that.hour = parseInt(that.limitTime / 60);
            that.minute = that.limitTime % 60;
            if (that.hour > 1 && that.minute == 0) {
              that.hour = that.hour - 1;
              that.minute = 59;
            } else {
              that.minute = that.limitTime % 60 - 1;
            }
  
          } else {
            that.minute = that.limitTime != undefined && that.limitTime > 0 ? that.limitTime - 1 : that.limitTime;
          }
          that.second = 60;
          int = setInterval(that.timer2, 1000); //每隔50毫秒执行一次timer函数
        } else {
          int = setInterval(that.timer, 1000); //每隔50毫秒执行一次timer函数
        }
      },
      close(){
        that.$refs.examDialog =''
        that.$emit('close')
        window.clearInterval(int);
      },

      photograph() {
      this.$refs.camera2.setImage();
      },
      startExam() {
        if (this.imgUlrList.length == 0) {
          this.$message.error("请点击拍照，拍照打卡后再开始做题")
        } else {
          this.dialogTableVisible = false;
        }
      },
      getUlr(imgUrl) {
        console.log(imgUrl, 'imgUrl');
        this.imgUlrList.push({
          url: imgUrl,
          type: 0
        }); //type=0抓拍  1手动拍摄
        this.imgUlrObj = "";
        this.imgUlrList.forEach(function (obj) {
          that.imgUlrObj = that.imgUlrObj + obj.url + ",";
        });
      },
      async getUlr2(imgUrl) {
        this.imgUlrObj = "";
        this.imgUlrList = []
        const data = {
          photoUrl:imgUrl,
          courseId:this.courseId,
          exerciseId:this.exerciseId,
          empId:this.$store.state.user.empId,
          type:1
        }
        const comparisonResult = await faceComparison(data)
        console.log(imgUrl, 'imgUrl');
        var isExist = false;
        this.imgUlrList.forEach(function (obj) {
          if (obj.type == 1) {
            isExist = true;
            obj.url = imgUrl
          }
        });
        if (!isExist) {
          this.imgUlrList.push({
            url: imgUrl,
            type: 1
          }); //type=0抓拍  1手动拍摄
        }
        this.imgUlrObj = "";
        this.imgUlrList.forEach(function (obj) {
          that.imgUlrObj = that.imgUlrObj + obj.url + ",";
        });
      },
      handleClose(done) {
        if (this.imgUlrList.length == 0) {
          this.$message.error("请点击拍照，拍照打卡后再开始做题")
        } else {
          done()
        }
      },
    },
    destroyed: function () {
      window.clearInterval(int);
    },
  }
  
</script>
<style lang="less" src="./examDialog.less"></style>
<style lang="less" src="../../less/publicStyle.less"></style>


// WEBPACK FOOTER //
// src/components/examDialog/examDialog.vue